import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '../../users/users.service';
import { ActionLoaderComponent } from '../action-loader/action-loader.component';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-enable-user-request-dialog',
  template: `
    <h1 mat-dialog-title>Gestionar acceso de {{ clientName }}</h1>
    <div mat-dialog-content>
      <form [formGroup]="form">
        <div fxLayout="row wrap">
          <div class="p-10" fxFlex="100">
            <mat-form-field>
              <input matInput placeholder="# Raqueta *" maxLength="20" [formControl]="form.controls['username']" />
              <mat-hint
                *ngIf="
                  (form.controls['username'].hasError('required') ||
                    form.controls['username'].hasError('isWhitespace')) &&
                  form.controls['username'].touched
                "
                class="text-danger font-14"
                >Debe indicar un identificador de raqueta</mat-hint
              >
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
    <div mat-dialog-actions>
      <div class="m-r-5">
        <button
          mat-raised-button
          color="accent"
          (click)="this.dialogRef.close()"
          [disabled]="saveUser.isRunning"
          tabindex="2"
        >
          Cancelar
        </button>
        <div class="m-t-10"></div>
      </div>
      <app-action-loader #disablingUser>
        <button
          mat-raised-button
          color="accent"
          class="disabled-usr-button"
          (click)="onDisableUser()"
          tabindex="1"
          matTooltip="El usuario podrá ingresar pero no podrá hacer pujas"
          [disabled]="saveUser.isRunning || disablingUser.isRunning"
        >
          Inhabilitar
        </button>
      </app-action-loader>
      <app-action-loader #saveUser>
        <button
          mat-raised-button
          color="primary"
          (click)="onEnableUser()"
          tabindex="1"
          [disabled]="!form.valid || saveUser.isRunning || disablingUser.isRunning"
        >
          Habilitar
        </button>
      </app-action-loader>
    </div>
  `,
  styles: ['.disabled-usr-button { margin-right: 10px;  }'],
})
export class DialogEnableUserRequestComponent implements OnInit {
  clientName: string;
  form: FormGroup;
  @ViewChild('saveUser')
  public saveUserLoader: ActionLoaderComponent;
  @ViewChild('disablingUser')
  public disablingUserLoader: ActionLoaderComponent;

  constructor(
    private userService: UserService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<DialogEnableUserRequestComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.clientName = this.data.client;
  }

  onEnableUser() {
    if (!this.form.valid) {
      return;
    }
    const formData = { id: this.data.id, username: this.form.value.username };
    formData.username = !isNaN(formData.username) ? `Raqueta # ${formData.username}` : formData.username;
    this.saveUserLoader.start();
    this.userService
      .enable(formData.id, formData.username)
      .then(() => {
        this.dialogRef.close(formData);
        this.notificationService.success('Usuario habilitado correctamente');
      })
      .catch((err) => this.notificationService.error(err))
      .finally(() => this.saveUserLoader.stop());
  }

  onDisableUser() {
    this.disablingUserLoader.start();
    this.userService
      .disable(this.data.id)
      .then(() => {
        this.dialogRef.close(this.data.id);
        this.notificationService.success('Usuario deshabilitado correctamente');
      })
      .catch((err) => this.notificationService.error(err))
      .finally(() => this.disablingUserLoader.stop());
  }

  private buildForm() {
    this.form = this.fb.group({
      username: [null, Validators.required],
    });
  }
}
